"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arrayAverage = exports.elementWiseSum = exports.arraySum = void 0;
/**
 *  Empty arrays return 0
 * @param array
 * @returns the sum of all array elements
 */
const arraySum = (array) => array.reduce((total, current) => total + current, 0); // Start with zero so empty array does not runtime error
exports.arraySum = arraySum;
/**
 *
 * @param array1
 * @param array2
 * @returns a single array of the pairwise sums
 */
const elementWiseSum = (array1, array2) => array1.map((_, i) => array1[i] + array2[i]);
exports.elementWiseSum = elementWiseSum;
const arrayAverage = (array) => (0, exports.arraySum)(array) / array.length;
exports.arrayAverage = arrayAverage;
